import { useCallback } from 'react';

import { countMetrika } from '../../../helpers/metrika';
import { useActions } from '../../../hooks';

export function useOnPermissionChange(action: (payload: boolean) => void, metrikaKey: string) {
    const actions = useActions({ action });

    return useCallback(
        ({ target }) => {
            const { checked } = target;

            countMetrika('meeting_screen', 'settings', metrikaKey, checked ? 'allow' : 'deny');

            actions.action(checked);
        },
        [actions, metrikaKey]
    );
}
